// Distance unit formatting (aligned with Zeus).

const UNIT_CONVERSIONS = {
    distance: {
        metric: {
            base: 1,
            unit: 'm',
            large: 1000,
            largeUnit: 'km',
            threshold: 1000,
        },
        imperial: {
            base: 3.28084,
            unit: 'ft',
            large: 5280,
            largeUnit: 'mi',
            threshold: 5280,
        },
        nautical: {
            base: 0.000539957,
            unit: 'nmi',
            large: null,
            largeUnit: null,
            threshold: null,
        },
    },
};

function formatUnit(
    meters,
    unitType,
    unitSystem,
    decimalPlaces = 1,
    useMultipleUnits = true,
    showLabel = true,
) {
    if (meters == null || isNaN(meters)) {
        return showLabel ? '--' : '--';
    }

    const conversion = UNIT_CONVERSIONS[unitType]?.[unitSystem];
    if (!conversion) {
        return showLabel ? '--' : '--';
    }

    const converted = meters * conversion.base;
    let value = converted;
    let unit = conversion.unit;

    if (
        useMultipleUnits &&
        conversion.large &&
        conversion.threshold &&
        Math.abs(converted) >= conversion.threshold
    ) {
        value = converted / conversion.large;
        unit = conversion.largeUnit;
    }

    const formatted = value.toFixed(decimalPlaces);
    if (showLabel) {
        return formatted + ' ' + unit;
    }
    return formatted;
}

function formatDistance(
    meters,
    unitSystem,
    decimalPlaces = 1,
    useMultipleUnits = true,
    showLabel = true,
) {
    return formatUnit(
        meters,
        'distance',
        unitSystem,
        decimalPlaces,
        useMultipleUnits,
        showLabel,
    );
}

// Map chart depth-unit preference to a distance unit system for measure display.
function distanceUnitsFromDepthUnits(depthUnits) {
    if (depthUnits === 'feet') {
        return 'imperial';
    }
    if (depthUnits === 'fathoms') {
        return 'nautical';
    }
    return 'metric';
}

export { formatDistance, distanceUnitsFromDepthUnits };
